import ViewARoom from './view-a-room';
import ViewAHost from './view-a-host';
import ViewBlankPage from './view-blank-page';
import ViewACustomer from './view-a-customer';
import AdminLogin from './admin-login';
import ViewCityList from './view-city-list';
import ViewCityDetails from './view-city-detail';
import ViewAnOrder from './view-an-order';

export const Pages = {
  AdminLogin,
  ViewARoom,
  ViewAHost,
  ViewBlankPage,
  ViewACustomer,
  ViewCityList,
  ViewCityDetails,
  ViewAnOrder,
};

